import { TrialPlanConfirmationDialogWrapper } from '../account/components/trial-plan-confirmation-dialog';
import { DisableAccountDialog } from '../admin/admin-panel/account-status-transitions/status-transition-dialogs/disable-account-dialog';
import { TrialStartedAccountDialog } from '../admin/admin-panel/account-status-transitions/status-transition-dialogs/trial-started-account-dialog';

export const ACCOUNT_STATUS: Readonly<{
  [s in AccountStatus]: AccountStatus;
}> = Object.freeze({
  PRE_TRIAL: 'PRE_TRIAL',
  TRIAL: 'TRIAL',
  TRIAL_LAPSED: 'TRIAL_LAPSED',
  PAYING_CUSTOMER: 'PAYING_CUSTOMER',
  CANCELED: 'CANCELED',
  CLOSED: 'CLOSED',
});

export const isAccountStatus = (val: any): val is AccountStatus =>
  Boolean(ACCOUNT_STATUS[val as keyof typeof ACCOUNT_STATUS]);

export const isAccountStatusArray = (val: any): val is AccountStatus[] =>
  Array.isArray(val) && val.filter((v) => isAccountStatus(v)).length === val.length;

export const ACCOUNT_STATUS_ORDER = [
  ACCOUNT_STATUS.PRE_TRIAL,
  ACCOUNT_STATUS.TRIAL,
  ACCOUNT_STATUS.TRIAL_LAPSED,
  ACCOUNT_STATUS.PAYING_CUSTOMER,
  ACCOUNT_STATUS.CANCELED,
  ACCOUNT_STATUS.CLOSED,
];

export const ACCOUNT_STATUS_CONFIG = {
  [ACCOUNT_STATUS.PRE_TRIAL]: {
    text: 'Pre-Trial',
    TransitionComponent: null,
    transitions: [
      {
        status: ACCOUNT_STATUS.CLOSED,
        text: 'Close - Lost',
      },
      {
        status: ACCOUNT_STATUS.TRIAL,
        text: 'Start Trial',
      },
    ],
  },
  [ACCOUNT_STATUS.TRIAL]: {
    text: 'Trial',
    TransitionComponent: TrialStartedAccountDialog,
    transitions: [
      {
        status: ACCOUNT_STATUS.CLOSED,
        text: 'Close - Lost',
      },
      {
        status: ACCOUNT_STATUS.PAYING_CUSTOMER,
        text: 'Convert',
      },
    ],
  },
  [ACCOUNT_STATUS.TRIAL_LAPSED]: {
    text: 'Trial Ended',
    TransitionComponent: null,
    transitions: [
      {
        status: ACCOUNT_STATUS.CLOSED,
        text: 'Close - Lost',
      },
      {
        status: ACCOUNT_STATUS.PAYING_CUSTOMER,
        text: 'Convert',
      },
    ],
  },
  [ACCOUNT_STATUS.PAYING_CUSTOMER]: {
    text: 'Active Customer',
    TransitionComponent: TrialPlanConfirmationDialogWrapper,
    transitions: [
      {
        status: ACCOUNT_STATUS.CANCELED,
        text: 'Cancel',
      },
    ],
  },
  [ACCOUNT_STATUS.CANCELED]: {
    text: 'Canceled',
    TransitionComponent: null,
    transitions: [
      {
        status: ACCOUNT_STATUS.PAYING_CUSTOMER,
        text: 'Renew',
      },
      {
        status: ACCOUNT_STATUS.CLOSED,
        text: 'Closed',
      },
    ],
  },
  [ACCOUNT_STATUS.CLOSED]: {
    text: 'Closed',
    TransitionComponent: DisableAccountDialog,
    transitions: [
      {
        status: ACCOUNT_STATUS.PRE_TRIAL,
        text: 'Pre-Trial',
      },
      {
        status: ACCOUNT_STATUS.TRIAL,
        text: 'Trial',
      },
      {
        status: ACCOUNT_STATUS.TRIAL_LAPSED,
        text: 'Trial Ended',
      },
    ],
  },
};
